import { useEffect, useState } from 'react';
import { breakpoints } from '@bms2/shared';

/**
 * Whether the viewport stands under the md breakpoint (T2251). 🔨 Read from the media query, so a
 * rotated phone and a resized window both move it; a browser with no media queries reads as a
 * desktop. The editor's bars and the Dispatch Board's strips both read it from here.
 */
export function usePhoneWidth(): boolean {
  return useBelowWidth(breakpoints.md);
}

/**
 * Whether the viewport stands under the given width, read from the media query as the phone's is. A caller names a
 * width from the shared breakpoints, never a literal (T3685: the document rail's `documentRailBeside`).
 */
export function useBelowWidth(widthPx: number): boolean {
  const media = `(min-width: ${widthPx}px)`;
  const [below, setBelow] = useState(() => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && !window.matchMedia(media).matches);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const query = window.matchMedia(media);
    const changed = () => setBelow(!query.matches);
    changed();
    query.addEventListener?.('change', changed);
    return () => query.removeEventListener?.('change', changed);
  }, [media]);
  return below;
}
